import React, { PureComponent } from 'react';

class DateInputButton extends PureComponent {
  render() {
    return (
      <button
        type="button"
        className="NewInput NewInput--white"
        onClick={this.props.onClick}
      >
        {this.props.value || '…'}
      </button>
    );
  }
}

export default DateInputButton;
